export enum CartModalKind {
	OrderError = "OrderError",
	ClearForSubscription = "ClearForSubscription",
	ClearForProducts = "ClearForProducts",
}
